import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';

@Component({
  selector: 'app-checkbox-vehicle',
  templateUrl: './checkbox-vehicle.component.html',
  styleUrls: ['./checkbox-vehicle.component.scss'],
})
export class CheckboxVehicleComponent {
  @Input() descriptionCheckBoxOff = '';
  @Input() descriptionCheckBoxOn = '';
  @Input() isChecked = true;
  @Input() idCheckbox = 'test';
  @Output() checkboxState = new EventEmitter<boolean>();

  toggleCheck(): void {
    this.isChecked = !this.isChecked;
    this.checkboxState.emit(this.isChecked);
  }
}
